import type { ComponentProps } from "react";
import type { Card } from "@telia/teddy";

export type UspCardConfiguration = Required<Pick<ComponentProps<typeof Card>, "variant" | "layout">>;

export const USP_CARD_VARIANTS = [
    "purple-light",
    "purple-dark",
    "gray",
    "white",
    "beige",
    "beige-light",
] as const satisfies readonly UspCardConfiguration["variant"][];

export const USP_CARD_LAYOUTS = [
    "navigation-vertical",
    "navigation-horizontal-small",
    "navigation-horizontal-small-centered",
    "navigation-horizontal-large",
    "rich-card",
    "rich-card-large",
    "default",
    "product",
] as const satisfies readonly UspCardConfiguration["layout"][];

export const USP_LEGACY_CARD_PRESETS = {
    "small-white-cards-grid": { variant: "white", layout: "navigation-vertical" },
    "small-beige-cards-grid": { variant: "beige", layout: "navigation-horizontal-small" },
    "small-purple-cards-grid": { variant: "purple-light", layout: "navigation-horizontal-small" },
} as const satisfies Record<string, UspCardConfiguration>;
